module.exports = __webpack_public_path__ + "static/media/angle-right.4cdc7f1e.svg";